import { flow } from 'fp-ts/function';
import { __, at, get, invoke, join, map } from 'lodash/fp';
import { createSelector } from 'reselect';
import { Day, WeekDay } from '@mews/enums';
import { getProp, getStringProp } from '@mews/fp';
import { composeProps, createPropsExtender } from '@mews/framework';
import { dateTimeToLocalizedDate } from '@mews-commander/utils';
import { getRateName } from '@mews-commander/legacy-entities/src/ducks/rates';
import { getResourceCategoryName } from '@mews-commander/legacy-entities/src/ducks/resourceCategories';
import { getDayShortNames } from '@mews-commander/core/legacy-globalization';
import { getRestrictionsModule } from './common';
import { getDateFromDateRangeArrayByIndex, getSelectedCell } from './matrix';

export const getSidebar = createSelector(getRestrictionsModule, get('sidebar'));

export const isSidebarOpened = createSelector(getSidebar, get('isOpened'));

const getSidebarDate = composeProps(
    getDateFromDateRangeArrayByIndex,
    createPropsExtender('columnIndex', flow(getSelectedCell, get('columnIndex')))
);

export const getSidebarDateString = createSelector(getSidebarDate, dateTimeToLocalizedDate);

const getDayEnumValue = flow(Day.getByName, get('value'));

export const getShortenedDayNames = createSelector(
    getDayShortNames,
    getProp<WeekDay[]>()('days'),
    (shortLocalizedDayNames, restrictedDayStrings) => {
        const transformToShortLocalizedDayNames = flow(
            map(getDayEnumValue),
            invoke('sort'),
            at(__, shortLocalizedDayNames),
            join(' ')
        );
        return transformToShortLocalizedDayNames(restrictedDayStrings);
    }
);

export const getSidebarExactRateName = composeProps(
    getRateName,
    createPropsExtender('rateId', getStringProp('exactRateId'))
);
export const getSidebarBaseRateName = composeProps(
    getRateName,
    createPropsExtender('rateId', getStringProp('baseRateId'))
);
export const getSidebarResourceCategoryName = composeProps(
    getResourceCategoryName,
    createPropsExtender('id', getStringProp('resourceCategoryId'))
);
